/* Sémantique des setters de React : une valeur, ou une fonction de mise à jour recevant la
   valeur courante. */
export const resolveUpdate = (suivant, current) =>
  typeof suivant === 'function' ? suivant(current) : suivant;
